import { Button, Tooltip, Typography, Modal } from "antd";
import localforage from "localforage";
import { useState, useRef } from "react";
import html2canvas from "html2canvas";

import {
  MenuOutlined,
  EnvironmentFilled,
  ReloadOutlined,
  ArrowLeftOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

export default function Header({
  selectedBusinessType,
  isLoggedIn,
  currentLocation,
  setShowSidebar,
  setSelectedBusinessType,
  fetchNearbyBusinesses,
  showUserStatus,
  setShowChangeLocationModal,
  isMobile,
  getFavorites,
  setSearchValue,
  businessName
}) {
  const bannerRef = useRef(null);
  const [isBannerVisible, setIsBannerVisible] = useState(false);

  const handleDownloadBanner = async () => {
    if (!bannerRef.current) return;
    try {
      const canvas = await html2canvas(bannerRef.current, { scale: 2 });
      const dataURL = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = `${businessName ? businessName.replace(/\s+/g, "_") : "business"}_banner.png`;
      link.click();
    } catch (error) {
      console.error("Failed to download banner:", error);
    }
  };

  return (
    <header className="header-container">
      <div className="header-content">
        {selectedBusinessType && !isLoggedIn ? (
          <Tooltip title="Back">
            <Button
              type="text"
              onClick={() => setSelectedBusinessType(null)}
              className="back-button"
            >
              <ArrowLeftOutlined />
            </Button>
          </Tooltip>
        ) : null}
        <Button
          type="text"
          onClick={() => setShowSidebar(true)}
          className="menu-button"
        >
          <MenuOutlined />
        </Button>
        {isLoggedIn && (
          <Button
            className="show-banner-button"
            onClick={() => setIsBannerVisible(true)}
            style={{ 
              float: "right", 
              marginRight: "10px", 
              backgroundColor: "#c8e3ed",
              color: "#0077b6",
              border: "none",
              fontWeight: 600
            }}
          >
            Show Banner
          </Button>
        )}
        {selectedBusinessType && !isMobile && !isLoggedIn ? (
          <Tooltip title="Refresh">
            <Button
              type="text"
              onClick={async () => {
                let favoritesEnable = await localforage.getItem("favorites_enable");
                (favoritesEnable || false) ? getFavorites() : fetchNearbyBusinesses(currentLocation)
                setSearchValue("")
              }}
              className="refresh-button"
              style={{
                fontSize: "24px",
                filter: "drop-shadow(0.5px 0 0 currentColor)", // Adjust the shadow to make it bolder
              }}
            >
              <ReloadOutlined />
            </Button>
          </Tooltip>
        ) : null}
        {!isLoggedIn ? (
          <Button
            type="text"
            onClick={() => {
              setShowChangeLocationModal(true);
            }}
            className="addressHeaderContainer"
          >
            <EnvironmentFilled className="mr-2" />
            <span className="address-text">
              {currentLocation
                ? currentLocation.address
                : "Loading location..."}
            </span>
          </Button>
        ) : null}
        {showUserStatus && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Text
              type="warning"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <ClockCircleOutlined className="mr-2" style={{marginRight: "5px"}} />
              Verification in progress
            </Text>
          </div>
        )}
      </div>

      <Modal
        open={isBannerVisible}
        onCancel={() => setIsBannerVisible(false)}
        footer={null}
        width={500}
        styles={{ body: { padding: 0, overflow: "hidden", borderRadius: "8px" } }}
        closable={false}
        destroyOnClose
      >
        <Button
          shape="circle"
          icon={<CloseOutlined />}
          size="small"
          onClick={() => setIsBannerVisible(false)}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 10,
            border: "none",
            background: "rgba(255, 255, 255, 0.5)",
          }}
        />
        <div
          ref={bannerRef}
          style={{
            background: "linear-gradient(to bottom, #87CEEB, #E0F7FA)",
            padding: "40px 20px 30px 20px",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: "32px",
              fontWeight: "bold",
              color: "#1a1a1a",
              marginBottom: "15px",
              lineHeight: "1.2",
            }}
          >
            {businessName}
          </h1>
          <h2
            style={{
              fontSize: "24px",
              color: "#333",
              fontWeight: "500",
              marginBottom: "25px",
            }}
          >
            Visit quetracker.com or
            <br />
            download the app on android
          </h2>
          <div style={{ display: "inline-block", maxWidth: "100%" }}>
            <img
              src="/playStoreImg.jpg"
              alt="QueTracker Play Store"
              style={{
                width: "100%",
                maxWidth: "400px",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            />
          </div>
        </div>
        
        <div style={{ padding: "15px", background: "#f0f2f5" }}>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            size="large"
            block
            onClick={handleDownloadBanner}
          >
            Download Banner
          </Button>
        </div>
      </Modal>
    </header>
  );
}
